"use client"
import React, { useEffect, useState } from "react"
import * as classes from "./projectSection.module.scss"
import SlideWrapper from "@/components/Shared/SlideWrapper/slideWrapper"
import { isBrowser } from "../../../../utils/utils"
import dynamic from "next/dynamic"
const ReactPlayer = dynamic(() => import("react-player"), { ssr: false })
const ProjectSection = ({ projectSectionData, theme }) => {
  const { heading, imgSrc, videoLink, deepdescription } = projectSectionData
  const [showButton, setShowButton] = useState(false)
  const [buttonStatus, setButtonStatus] = useState(false)
  const [videoError, setVideoError] = useState(false)
  useEffect(() => {
    if (isBrowser) {
      const projectContainer = document.getElementById("projectSection")
      const projectContainerHeight = projectContainer.clientHeight
      setShowButton(projectContainerHeight > 330)
    }
  }, [])
  return (
    <>
      <div
        className={classes["projectSectionWrapper"]}
        style={{
          fontFamily: theme.fontFamilyPrimary,
        }}
      >
        <SlideWrapper
          triggerOnce
          direction={"left"}
          style={{ width: "100%", height: "100%" }}
        >
          <div className={classes["leftSideSection"]}>
            {videoLink && !videoError ? (
              // <span dangerouslySetInnerHTML={{ __html: videoLink }}></span>
              <div className={classes["videoWrapper"]}>
                <ReactPlayer
                  className={classes["react-player"]}
                  width="100%"
                  height="100%"
                  url={videoLink}
                  controls={true}
                  onError={() => {
                    setVideoError(true)
                  }}
                />
              </div>
            ) : (
              <img src={imgSrc} alt=" project" />
            )}
          </div>
        </SlideWrapper>
        <SlideWrapper
          triggerOnce
          direction={"right"}
          style={{ width: "100%", height: "100%" }}
        >
          <div className={classes["detailWrapper"]}>
            <div
              style={{ color: theme.primaryTextColor }}
              className={classes["heading"]}
            >
              {heading}
            </div>
            <div
              id="projectSection"
              dangerouslySetInnerHTML={{ __html: deepdescription }}
              style={{
                color: theme.secondaryTextColor,
                fontFamily: theme.fontFamilySecondary,
              }}
              className={
                !showButton
                  ? classes.desc
                  : buttonStatus
                  ? classes.desc
                  : classes.slicedTextContainer
              }
            ></div>

            {showButton && (
              <button
                className={classes["buttonReadMore"]}
                style={{
                  color: theme.primaryTextColor,
                }}
                onClick={() => {
                  setButtonStatus(!buttonStatus)
                }}
              >
                {buttonStatus ? "See Less" : "Read More"}
              </button>
            )}
          </div>
        </SlideWrapper>
      </div>
    </>
  )
}

export default ProjectSection
